import { useState } from "react"
import {
  Box,
  Typography,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  Chip,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@mui/material"
import { Visibility as ViewIcon } from "@mui/icons-material"
import { useApiQuery } from "../../hooks/useApi"
import { useAuth } from "../../contexts/AuthContext"

function CancelledJobsPage() {
  const [page, setPage] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(10)
  const [selectedJob, setSelectedJob] = useState(null)
  const [dialogOpen, setDialogOpen] = useState(false)

  const { user } = useAuth()

  const { data: cancelledJobs, isLoading } = useApiQuery(["cancelledJob", user?._id],`jobs/cancelled`)

  const handleChangePage = (event, newPage) => {
    setPage(newPage)
  }

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(Number.parseInt(event.target.value, 10))
    setPage(0)
  }

  const handleView = (job) => {
    // console.log('cancelledJon handleView job', job)
    setSelectedJob(job)
    setDialogOpen(true)
  }

  const getPriorityColor = (priority) => {
    const colors = {
      High: "error",
      Medium: "warning",
      Low: "success",
    }
    return colors[priority] || "default"
  }

  if (isLoading) {
    return <Typography>Loading cancelled jobs...</Typography>
  }

  const displayJobs = cancelledJobs || []
  const paginatedJobs = displayJobs.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)

  return (
    <Box>
      <Typography variant="h4" component="h1" gutterBottom>
        Cancelled Jobs
      </Typography>
      <Typography variant="body1" color="textSecondary" paragraph>
        Review all jobs that have been successfully cancelled.
      </Typography>

      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Job ID</TableCell>
              <TableCell>Client</TableCell>
              <TableCell>Job Type</TableCell>
              <TableCell>Due Date</TableCell>
              <TableCell>Cancelled On</TableCell>
              {/* <TableCell>Fee</TableCell> */}
              {/* <TableCell>Actions</TableCell> */}
            </TableRow>
          </TableHead>
          <TableBody>
            {paginatedJobs.map((job) => (
              <TableRow key={job.JobId} hover>
                <TableCell>
                  <Typography variant="subtitle2" sx={{ fontFamily: "monospace" }}>
                    {job.JobId}
                  </Typography>
                </TableCell>
                <TableCell>
                  <Box>
                    <Typography variant="subtitle2">{job.clientName}</Typography>
                    <Typography variant="caption" color="textSecondary">
                      {job.clientPhoneNumber}
                    </Typography>
                  </Box>
                </TableCell>
                <TableCell>{job.jobType}</TableCell>
                <TableCell>{new Date(job.dueDate).toLocaleDateString()}</TableCell>
                <TableCell>
                  {job.cancelledAt ? new Date(job.cancelledAt).toLocaleDateString() : "-"}
                </TableCell>
                {/* <TableCell>₹{job.fees?.toLocaleString()}</TableCell> */}
                <TableCell>
                  <IconButton color="primary" onClick={() => handleView(job)} size="small">
                    <ViewIcon />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}

            {paginatedJobs.length === 0 && (
              <TableRow>
                <TableCell colSpan={8} align="center">
                  No cancelled jobs found.
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>

        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={displayJobs.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </TableContainer>

      {/* View Job Dialog */}
      <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)} maxWidth="sm" fullWidth>
        <DialogTitle>Job Details</DialogTitle>
        <DialogContent>
          {selectedJob && (
            <Box sx={{ mt: 1 }}>
              <Typography variant="h6" gutterBottom>
                {selectedJob.JobId} - {selectedJob.jobType}
              </Typography>
              <Typography variant="body2" color="textSecondary" paragraph>
                Client: {selectedJob.clientName}
              </Typography>
              <Typography variant="body2" paragraph>
                {`Reason of Cancellation: ${selectedJob?.statusHistory?.[selectedJob.statusHistory.length - 1]?.reason}`}
              </Typography>
              <Typography variant="body2" color="textSecondary">
                Cancelled On: {new Date(selectedJob.cancelledAt).toLocaleDateString()}
              </Typography>
              <Typography variant="body2" color="textSecondary">
                Due Date: {new Date(selectedJob.dueDate).toLocaleDateString()}
              </Typography>
              <Typography variant="body2" color="textSecondary">
                Fee: ₹{selectedJob?.fees || 'N/A'}
              </Typography>
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDialogOpen(false)}>Close</Button>
        </DialogActions>
      </Dialog>
    </Box>
  )
}

export default CancelledJobsPage;